<template>
  <div class="form form-search" :style="style">
    <div class="form-group">
      <input type="text" placeholder="Enter name, nickname, or email" class="form-control" v-model="searchTerm" @keyup="showSearchResults" ref="emailInput">
      <input type="submit" value="Search" class="form-search__button" @click="showSearchResults" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchProfiles',
  emits: ['updateProfiles'],
  props: {
    top: {
      type: Number,
      default: 330
    }
  },
  computed: {
    style() {
      return `top: ${this.top}px`;
    }
  },
  methods: {
    showSearchResults() {
      this.$emit('updateProfiles', this.searchTerm);
    }
  },
  data() {
    return {
      searchTerm: this.$route.params.term
    }
  },
  mounted() {
    this.$refs.emailInput.focus();
  }
}
</script>

<style scoped>
  .form-search {
    z-index: 1;
    /* top: 230px; */
    margin: 0;
    position: fixed;
    width: 100%;
  }
</style>
